// Display labels for stored spot/truck size values (stored values never change).
const SIZE_LABELS = { Pole: "53 ft" };

export const sizeLabel = (v) => SIZE_LABELS[v] || v;

export const sizeValue = (label) =>
  Object.keys(SIZE_LABELS).find((k) => SIZE_LABELS[k].toLowerCase() === String(label).toLowerCase()) || label;
